import Vue from "vue";
import App from "./App.vue";
import i18n from "@/utils/i18n/index.js";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import { version } from "../package.json";
import "@/utils/platformSettings.js";

// Vuesax Component Framework
import Vuesax from "vuesax";
import notification from "vue-notification-ui";
Vue.use(notification, {
  position: "notification-top-right", // top, bottom, left, right
  duration: 5000, // default
  left: 20, // default
  bottom: 20, // default
  top: 20, // default
  right: 40, // default
});
import "material-icons/iconfont/material-icons.css"; //Material Icons
import "vuesax/dist/vuesax.css"; // Vuesax

import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import { baseURL } from "./productionStatus";
//import 'devextreme/dist/css/dx.dark.css';
import VueHtmlToPaper from "vue-html-to-paper";

const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://dev-panel.d7ksuper.com/assets/css/main.css",
    "https://dev-panel.d7ksuper.com/assets/scss/main.css",
    "https://dev-panel.d7ksuper.com/assets/css/iconfont.css",
    "https://dev-panel.d7ksuper.com/assets/css/loader.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css",
    "https://dev-panel.d7ksuper.com/loader.css",
    "https://cdn.jsdelivr.net/npm/vuesax/dist/vuesax.css",
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "https://fonts.googleapis.com/icon?family=Material+Icons",
  ],
  timeout: 1000, // default timeout before the print window appears
  autoClose: true, // if false, the window will not close after printing
  windowTitle: window.document.title, // override the window title
};

Vue.use(VueHtmlToPaper, options);
Vue.use(Vuesax);

import Autocomplete from "v-autocomplete";

// You need a specific loader for CSS files like https://github.com/webpack/css-loader
import "v-autocomplete/dist/v-autocomplete.css";

Vue.use(Autocomplete);

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

Vue.use(require("vue-moment"));

Vue.prototype.$apiUrl = baseURL;

// axios
import axios from "./axios.js";
Vue.prototype.$http = axios;

import VueMask from "v-mask";
Vue.use(VueMask);

axios.interceptors.request.use((config) => {
  //Token Bilgisi Global Olarak
  var token = localStorage.getItem("UserToken");
  config.headers["Authorization"] = "Bearer " + token;
  config.headers["Content-Type"] = "application/json";
  return config;
});

function LoadingRemoving() {
  const appLoading = document.getElementsByClassName(
    "vs-loading-color-null"
  )[0];
  if (appLoading) {
    appLoading.style.display = "none";
  }
}
axios.interceptors.response.use(null, async (error) => {
  if (error.response.status == 401) {
    localStorage.removeItem("UserToken");
    router.push({
      name: "pages/login",
    });
    LoadingRemoving();
  }
  if (error.response.status == 403) {
    router.push({
      name: "page-error-403",
    });
    LoadingRemoving();
  }
  return Promise.reject(error);
});

// Filters
import "./filters/filters.js";

//Printers
import "./filters/printerShaesk.js";

// Theme Configurations
import "../themeConfig.js";

// Globally Registered Components
import "./globalComponents.js";

// Styles: SCSS
import "./assets/scss/main.scss";

// Tailwind
import "@/assets/css/main.css";

// Vue Router
import router from "./router";

import VueMeta from "vue-meta";
Vue.filter("toCurrency", function (value, paraBirimi) {
  if (typeof value !== "number") {
    return value;
  }
  var birim = "";
  if (paraBirimi == "$") {
    birim = "USD";
  } else if (paraBirimi == "€") {
    birim = "EUR";
  } else if (paraBirimi == "£") {
    birim = "GBP";
  } else {
    birim = "TRY";
  }
  var formatter = new Intl.NumberFormat("tr-TR", {
    style: "currency",
    currency: birim,
    minimumFractionDigits: 0,
  });
  return formatter.format(value);
});

Vue.filter("formatter", function (value) {
  if (typeof value !== "number") {
    return value;
  }
  // Sayı formatlama işlemi
  var formatter = new Intl.NumberFormat("tr-TR", {
    style: "decimal", // "number" yerine "decimal" kullanmalısınız
    minimumFractionDigits: 2, // Ondalık basamak yok
    maximumFractionDigits: 2, // İsteğe bağlı: Maksimum 2 ondalık basamak
  });
  return formatter.format(value); // Formatlanmış sayıyı döndür
});

Vue.use(VueMeta);
// Vuex Store
import store from "./store/store";
import VueQRCodeComponent from "vue-qr-generator";
Vue.component("qr-code", VueQRCodeComponent);
// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from "vue2-hammer";
Vue.use(VueHammer);

// PrismJS
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";

// Feather font icon
require("./assets/css/iconfont.css");

import vueCalendar from "vue2-simple-calendar";

Vue.use(vueCalendar);

import * as firebase from "firebase/app";
import "firebase/messaging";
import "firebase/firestore";
import "firebase/analytics";

import { metadata } from "core-js/fn/reflect";

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

var firebaseConfig = {
  apiKey: "AIzaSyD9Y52PJbzf_k2m_ZXO4gKyW4hsr-R_T58",
  authDomain: "d7ksuper-panel-72a90.firebaseapp.com",
  projectId: "d7ksuper-panel-72a90",
  storageBucket: "d7ksuper-panel-72a90.appspot.com",
  messagingSenderId: "932344439468",
  appId: "1:932344439468:web:f933b3034a5de541aa3509",
  measurementId: "G-VTWBPXBJWS",
};

firebase.initializeApp(firebaseConfig);
firebase.analytics();

navigator.serviceWorker
  .register("../firebase-messaging-sw.js", {
    scope: "../firebase-cloud-messaging-push-scope",
  })
  .then((register) => {
    const messaging = firebase.messaging();
    messaging.useServiceWorker(register);
  })
  .catch((err) => {
    // console.log(err);
  });
Vue.config.productionTip = true;

//alias
Vue.prototype.$analytics = firebase.analytics();

Vue.prototype.$logWrite = function (propertyName, meta_data, meta_value) {
  var user = JSON.parse(localStorage.getItem("UserData"));
  this.$analytics.setUserId(user.email);
  this.$analytics.setUserProperties(user);
  firebase.analytics().setCurrentScreen(page);
  firebase.analytics().logEvent(propertyName, meta_data, meta_value);
};

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
